import {goBack, LOCATION_CHANGE} from "connected-react-router";

const POPHISTORYTYPE = 'POP_HISTORY';


const initialState = {
  breadcrumbs: []  
};


const locationRegex = /LN[0-9]+/;
const workorderRegex = /[SWFD]?[0-9]+/;


export const actionCreators = {
  popHistory: (key) => async (dispatch, getState) => {
    const popCount = getState().breadcrumbs.breadcrumbs.length - key - 1;

    let new_breadcrumbs = getState().breadcrumbs.breadcrumbs.slice();
    
    let i;
    for (i = 0 ; i < popCount ; i++) {
      dispatch(goBack());
      new_breadcrumbs.pop()
    }
    // new_breadcrumbs.pop();
    
    dispatch({type: POPHISTORYTYPE, new_breadcrumbs});
  }
};


export const reducer = (previousState, action) => {
  previousState = previousState || initialState;
  
  if (action.type === POPHISTORYTYPE) {
    return {
      ...previousState,
      breadcrumbs: action.new_breadcrumbs
    }
  }
  
  if (action.type === LOCATION_CHANGE) {
    const pathname = action.payload.location.pathname;
    const id = pathname.match(locationRegex) || pathname.match(workorderRegex);
    
    let concat_breadcrumb, new_breadcrumb;
    
    if (id) {
      concat_breadcrumb = {path: pathname, label: id[0], key: action.payload.location.key};
    } else {
      let label = pathname.replace('/', '');
      label = label.charAt(0).toUpperCase() + label.slice(1);
      new_breadcrumb = {path: pathname, label: label, key: action.payload.location.key}
    }
    
    if (concat_breadcrumb && previousState.breadcrumbs.length > 0 && previousState.breadcrumbs[previousState.breadcrumbs.length-1].label === concat_breadcrumb.label) {
      return {
        ...previousState,
      }
    } else if (concat_breadcrumb) {
      return {
        ...previousState,
        breadcrumbs: previousState.breadcrumbs.concat(concat_breadcrumb)
      }
    } else if (new_breadcrumb) {
      return {
        ...previousState,
        breadcrumbs: [new_breadcrumb]
      }
    }else {
      return {
        ...previousState,
        ...initialState
      }
    }
  }
  
  return previousState;
};